import React, { useState } from 'react';
import { Box, Button, Heading, Layer, TextInput } from 'grommet';
import { AddCircle, Close } from 'grommet-icons';
import { useRevalidator } from 'react-router-dom';
import PropTypes from 'prop-types';
import { CompanyService } from '@enrich/shared-lib';

export const AddCompanyReportRecipientButton = ({
    companyId,
    recipients = [],
    setNotification,
}) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <Button
                secondary
                label={
                    <span>
                        <AddCircle size="small" color="enrich-blue" /> Add
                    </span>
                }
                onClick={() => setShowModal(true)}
            />
            {showModal && (
                <AddCompanyReportRecipientModal
                    companyId={companyId}
                    recipients={recipients}
                    setShowModal={setShowModal}
                    setNotification={setNotification}
                />
            )}
        </>
    );
};

const AddCompanyReportRecipientModal = ({
    companyId,
    recipients = [],
    setShowModal,
    setNotification,
}) => {
    const [email, setEmail] = useState('');
    const [buttonBusy, setButtonBusy] = useState(false);
    const revalidator = useRevalidator();

    const addReportRecipient = async () => {
        setButtonBusy(true);
        try {
            const reportRecipients = [...recipients, email];

            await new CompanyService().update(companyId, {
                reportRecipients,
            });

            setShowModal(false);
            setNotification?.({
                status: 'normal',
                title: 'Success',
                message: 'Report recipient added.',
            });
            revalidator.revalidate();
        } catch (error) {
            console.log(error);
            const message =
                error.response?.data?.error?.message ||
                error.message ||
                'Failed to add report recipient.';
            setNotification?.({
                status: 'critical',
                title: 'Add failed',
                message,
            });
            setButtonBusy(false);
            return;
        }
        setButtonBusy(false);
    };

    return (
        <Layer
            onClickOutside={() => setShowModal(false)}
            onEsc={() => setShowModal(false)}
            position="center">
            <Box
                background="white"
                pad="medium"
                round="6px"
                border={{ color: 'enrich-green-light', size: '3px' }}
                alignSelf="center"
                gap="30px">
                <Box direction="row" gap="20px" justify="between">
                    <Heading level="3" margin={{ vertical: 'none' }}>
                        Add Report Recipient
                    </Heading>
                    <Box align="end">
                        <Close
                            onClick={() => {
                                setShowModal(false);
                            }}
                            cursor="pointer"
                        />
                    </Box>
                </Box>
                <Box>
                    <Box
                        width="medium"
                        align="center"
                        round="6px"
                        background="white">
                        <TextInput
                            dropHeight="medium"
                            onChange={(event) => setEmail(event.target.value)}
                            placeholder="Email"
                            value={email}
                        />
                    </Box>
                </Box>
                <Box>
                    <Button
                        size="medium"
                        fill="horizontal"
                        primary
                        busy={buttonBusy}
                        disabled={!email.length}
                        label="Add"
                        alignSelf="center"
                        onClick={addReportRecipient}
                    />
                </Box>
            </Box>
        </Layer>
    );
};

AddCompanyReportRecipientButton.propTypes = {
    companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    recipients: PropTypes.arrayOf(PropTypes.string),
    setNotification: PropTypes.func,
};

AddCompanyReportRecipientModal.propTypes = {
    companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    recipients: PropTypes.arrayOf(PropTypes.string),
    setShowModal: PropTypes.func,
    setNotification: PropTypes.func,
};
